import { lazyWithReload } from '@shared/utils/lazyWithReload';

/**
 * 라우터 단위 코드 스플리팅.
 * 조문객·상주의 구매 퍼널(부고장 → 화환 스토어 / 답례글 → 답례품 스토어)은 **기본 번들에 함께 싣는다**
 * (2026-11-03 사용자 결정: 청크 첫 로딩의 Suspense가 열린 모달을 닫아 구매가 끊긴 실사고 뒤, 속도보다 확실성).
 * 관리자·판매자·공급사·계정 화면만 처음 진입할 때 청크로 받는다. 청크 이름은 webpackChunkName 주석으로 고정.
 */
const importSellerRouter = () =>
  import(/* webpackChunkName: "flower-seller" */ '@route/SellerRouters/SellerRouter');
const importGiftSellerRouter = () =>
  import(
    /* webpackChunkName: "gift-seller" */ '@route/GiftSellerRouters/GiftSellerRouter'
  );
const importGiftBrandRouter = () =>
  import(/* webpackChunkName: "gift-brand" */ '@route/GiftBrandRouters/GiftBrandRouter');
const importAdminRouter = () =>
  import(/* webpackChunkName: "admin" */ '@route/AdminRouter');
const importGiftApiRouter = () =>
  import(/* webpackChunkName: "gift-api" */ '@route/GiftApiRouter');
const importBugoAuthRouter = () =>
  import(/* webpackChunkName: "bugo-auth" */ '@route/BugoRouters/BugoAuthRouter');
const importKakaoCallbackPage = () =>
  import(/* webpackChunkName: "kakao-callback" */ '@shared/page/KakaoCallbackPage');

export const SellerRouterLazy = lazyWithReload(() =>
  importSellerRouter().then((m) => ({ default: m.SellerRouter })),
);
export const GiftSellerRouterLazy = lazyWithReload(() =>
  importGiftSellerRouter().then((m) => ({ default: m.GiftSellerRouter })),
);
export const GiftBrandRouterLazy = lazyWithReload(() =>
  importGiftBrandRouter().then((m) => ({ default: m.GiftBrandRouter })),
);
export const AdminRouterLazy = lazyWithReload(() =>
  importAdminRouter().then((m) => ({ default: m.AdminRouter })),
);
export const GiftApiRouterLazy = lazyWithReload(() =>
  importGiftApiRouter().then((m) => ({ default: m.GiftApiRouter })),
);
export const BugoAuthRouterLazy = lazyWithReload(() =>
  importBugoAuthRouter().then((m) => ({ default: m.BugoAuthRouter })),
);
export const KakaoCallbackPageLazy = lazyWithReload(() =>
  importKakaoCallbackPage().then((m) => ({ default: m.KakaoCallbackPage })),
);
